import { useTranslation } from 'react-i18next';
import { ModalTemplate } from '../ModalTemplate';
import { ReactComponent as InventingIcon } from '../../../assets/img/remoteControl/inventing.svg';
import { SatisfactionContainer, SatisfactionDescription } from './styles';

interface SatisfactionSurveyProps {
  isOpen: boolean;
  onClose: () => void;
  onClickRate: () => void;
}

export const UserSatisfactionSurveyModal: React.FC<SatisfactionSurveyProps> = ({
  isOpen,
  onClose,
  onClickRate,
}) => {
  const { t } = useTranslation();

  return (
    <ModalTemplate
      isOpen={isOpen}
      onClose={onClose}
      imageText={(
        <SatisfactionContainer>
          <div>
            <InventingIcon />
          </div>
          <SatisfactionDescription>
            <h2>
              {t('comoEstaSendoSuaExperiencia')}
            </h2>
            <p>
              {t('suaOpiniaoEImportanteDescricao')}
            </p>
          </SatisfactionDescription>
        </SatisfactionContainer>
      )}
      title={t('pesquisaDeSatisfacao')}
      button1={t('queroAvaliarAgora')}
      button1Action={onClickRate}
      button2={t('agoraNaoObrigado')}
      button2Action={onClose}
    />
  );
};
